import * as React from "react";
import { useState, useEffect } from "react";
import logo from "../../assets/spero_logo_new.png";
import "./Login.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import InputBase from "@mui/material/InputBase";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import useMediaQuery from "@mui/material/useMediaQuery";
import user from "../../assets/user.png";
import key from "../../assets/key.png";
import { useAuth } from "../Context/ContextAPI";
import { useCall } from "../Context/CallContext";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { API_URL } from "../Config/api";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import { motion, AnimatePresence } from "framer-motion"; // <-- AnimatePresence import kiya
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function Loginextentions() {
  const { handleAuth } = useAuth();
  const { connectSocket } = useCall();
  const [login, setLogin] = useState({
    clg_ref_id: "",
    password: "",
    extensions: "",
  });
  const [extensionsList, setExtensionsList] = useState([]);
  const [extensionError, setExtensionError] = useState(false);
  const [userIdError, setUserIdError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  // Alerts States
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showExistErrorAlert, setShowExistErrorAlert] = useState(false);
  const [showExistErrorAlert1, setShowExistErrorAlert1] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [showExtAlert, setShowExtAlert] = useState(false);
  const [showExtRequiredAlert, setShowExtRequiredAlert] = useState(false);
  const [showHdOnlyAlert, setShowHdOnlyAlert] = useState(false);
  const [showSelect1111Alert, setShowSelect1111Alert] = useState(false);
  const [showTimeoutAlert, setShowTimeoutAlert] = useState(false);
  const [showNetworkDownAlert, setShowNetworkDownAlert] = useState(false);
  const [customAlert, setCustomAlert] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [isHdUser, setIsHdUser] = useState(false);

  const [forceLoginOpen, setForceLoginOpen] = useState(false);
  const [forceLoginLoading, setForceLoginLoading] = useState(false);
  const [pendingLoginValues, setPendingLoginValues] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchExtensions = async () => {
      if (!login.clg_ref_id.trim()) {
        setExtensionsList([]);
        setLogin((prev) => ({ ...prev, extensions: "" }));
        return;
      }

      try {
        const response = await fetch(
          `${API_URL}/web/extenstion_get/?clg_ref_id=${login.clg_ref_id}`,
        );
        const data = await response.json();

        let fetchedExtensions = [];
        if (Array.isArray(data)) {
          fetchedExtensions = data;
        } else if (data && data.extensions && Array.isArray(data.extensions)) {
          fetchedExtensions = data.extensions;
        }

        setExtensionsList(fetchedExtensions);

        // NAYA LOGIC: Agar sirf "1111" aaya hai toh auto-select karein
        if (
          fetchedExtensions.length === 1 &&
          String(fetchedExtensions[0]) === "1111"
        ) {
          setLogin((prev) => ({ ...prev, extensions: "1111" }));
          setExtensionError(false);
        } else {
          setLogin((prev) => ({ ...prev, extensions: "" }));
        }
      } catch (error) {
        console.error("Error fetching extensions:", error);
        setExtensionsList([]);
      }
    };

    fetchExtensions();
  }, [login.clg_ref_id]);

  const handleForceLogin = async () => {
    if (!pendingLoginValues) return;

    setForceLoginLoading(true);

    try {
      const response = await fetch(`${API_URL}/web/login/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...pendingLoginValues,
          want_to_login: "True",
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.log("Force login failed:", data);
        setForceLoginOpen(false);
        return;
      }

      // LOGIN SUCCESS
      setSuccessAlert(true);

      localStorage.setItem("loginTime", Date.now());
      localStorage.setItem(
        "selected_extension",
        pendingLoginValues.selected_extension || ""
      );
      // localStorage.setItem(
      //   "selected_extension",
      //   login.extensions || ""
      // );
      localStorage.setItem("token", data.token.access);
      localStorage.setItem("refresh", data.token.refresh);
      localStorage.setItem(
        "user-image",
        data.token.colleague.profile_photo_path
      );
      localStorage.setItem(
        "user-name",
        data.token.colleague.first_name
      );
      localStorage.setItem(
        "user-lname",
        data.token.colleague.last_name
      );
      localStorage.setItem(
        "user-email",
        data.token.colleague.email
      );
      localStorage.setItem(
        "user-phone",
        data.token.colleague.phone_no
      );
      localStorage.setItem(
        "user-loc",
        data.token.colleague.address
      );
      localStorage.setItem(
        "user-designation",
        data.token.colleague.designation
      );
      localStorage.setItem("clg_id", data.token.colleague.id);
      localStorage.setItem(
        "hospitalId",
        data.token.colleague.clg_hosp_id
      );
      localStorage.setItem(
        "clgrefId",
        data.token.colleague.clg_ref_id
      );
      localStorage.setItem(
        "user_group",
        data.token.user_group
      );
      localStorage.setItem(
        "permissions",
        JSON.stringify(data.token.permissions)
      );
      localStorage.setItem(
        "companyID",
        data.token.colleague.prof_compny
      );

      const selectedExtension =
        pendingLoginValues.selected_extension || "";

      if (
        data.token.user_group === "hd" &&
        selectedExtension &&
        String(selectedExtension) !== "1111"
      ) {
        connectSocket(selectedExtension);
      } 
      // if (
      //   data.token.user_group === "hd" &&
      //   login.extensions &&
      //   String(login.extensions) !== "1111"
      // ) {
      //   connectSocket(login.extensions);
      // }

      setForceLoginOpen(false);

      setTimeout(() => {
        const group = data.token.user_group;

        handleAuth();

        if (group === "hd") navigate("/dashboard");
        else if (group === "HR") navigate("/hr/manage profiles");
        else if (group === "M_DASH") navigate("/MM2Dashboard");
        else if (group === "HR Partner")
          navigate("/hr partner/manage professionals");
        else if (group === "ADMIN")
          navigate("/hhc/dashboard");
        else if (group === "ACCOUNT")
          navigate("/hhc/account/dashboard");
        else if (group === "REPORTS")
          navigate("/reports/dashboard");
        else if (group === "HOSPITAL")
          navigate("/hospital/dashboard");
        else if (group === "ATTENDANCE")
          navigate("/attendance/attendance-view");
        else if (group === "MANAGEMENT")
          navigate("/management/management-dashboard");
        else if (group === "clincal_gov")
          navigate("/hhc/clinical/closure");
        else if (group === "HHC_Analytics")
          navigate("/analytics/home");
        else if (group === "physio")
          navigate("/physio");
        else if (group === "physioMilestone")
          navigate("/physioMilestone");
        else if (group === "Consultant")
          navigate("/hhc/consultant/referred patient details");

        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Force login error:", error);
    } finally {
      setForceLoginLoading(false);
    }
  };

  const handleChange = async (e) => {
    e.preventDefault();

    const isIdEmpty = !login.clg_ref_id || login.clg_ref_id.trim() === "";
    const isPassEmpty = !login.password || login.password.trim() === "";

    const isExtEmpty =
      shouldShowDropdown &&
      (!login.extensions || String(login.extensions).trim() === "");

    setUserIdError(isIdEmpty);
    setPasswordError(isPassEmpty);
    setExtensionError(isExtEmpty);

    if (isIdEmpty || isPassEmpty || isExtEmpty) {
      return;
    }

    const userId = login.clg_ref_id.trim().toLowerCase();
    const selectedExt = String(login.extensions).trim();

    // Admin Validation (Pre-API Call Check)
    if (userId === "admin" && selectedExt !== "1111") {
      setCustomAlert("For Admin login, please select extension 1111");
      setTimeout(() => setCustomAlert(""), 4000);
      return;
    }

    if (isHdUser && selectedExt === "") {
      setExtensionError(true);
      return;
    }

    setLoading(true);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try {
      const currentUrl = window.location.href;
      let isCloudValue = "True"; // Default

      if (
        currentUrl.includes("192.168.1.109:8000") ||
        currentUrl.includes("localhost")
      ) {
        isCloudValue = "False";
      } else {
        isCloudValue = selectedExt === "1111" ? "False" : "True";
      }

      const response = await fetch(`${API_URL}/web/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          clg_ref_id: login.clg_ref_id,
          password: login.password,
          extension_no: login.extensions || "",
          is_cloud: isCloudValue,
        }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (response.status >= 500) {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowSelect1111Alert(true);
          setTimeout(() => setShowSelect1111Alert(false), 5000);
        }
        setLoading(false);
        return;
      }

      if (response.status === 401) {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowExistErrorAlert1(true);
          setTimeout(() => setShowExistErrorAlert1(false), 3000);
        }
        setLoading(false);
        return;
      } else if (response.status === 404) {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowErrorAlert(true);
          setTimeout(() => setShowErrorAlert(false), 3000);
        }
        setLoading(false);
        return;
      } else {
        const data = await response.json();

        if (data.msg === "Extension login allowed only for HD users") {
          setShowHdOnlyAlert(true);
          setTimeout(() => setShowHdOnlyAlert(false), 4000);
          setLoading(false);
          return;
        }

        if (data.msg === "Extension is required for HD users") {
          setIsHdUser(true);
          setShowExtRequiredAlert(true);
          setExtensionError(true);
          setLoading(false);
          return;
        }

        if (data.msg === "Extension already logged in with another user") {
          setShowExtAlert(true);
          setTimeout(() => setShowExtAlert(false), 4000);
          setLoading(false);
          return;
        }

        if (data.msg === "User Already Logged In. Please check.") {
          setPendingLoginValues({
            clg_ref_id: login.clg_ref_id,
            password: login.password,
            extension_no: login.extensions || "",
            is_cloud: isCloudValue,
            selected_extension: login.extensions || "",
          });

          setForceLoginOpen(true);
          setLoading(false);
          return;
        }
        else {
          // LOGIN SUCCESS & ROUTING
          setSuccessAlert(true);

          localStorage.setItem("loginTime", Date.now());
          localStorage.setItem("selected_extension", login.extensions);
          localStorage.setItem("token", data.token.access);
          localStorage.setItem("refresh", data.token.refresh);
          localStorage.setItem(
            "user-image",
            data.token.colleague.profile_photo_path,
          );
          localStorage.setItem("user-name", data.token.colleague.first_name);
          localStorage.setItem("user-lname", data.token.colleague.last_name);
          localStorage.setItem("user-email", data.token.colleague.email);
          localStorage.setItem("user-phone", data.token.colleague.phone_no);
          localStorage.setItem("user-loc", data.token.colleague.address);
          localStorage.setItem(
            "user-designation",
            data.token.colleague.designation,
          );
          localStorage.setItem("clg_id", data.token.colleague.id);
          localStorage.setItem("hospitalId", data.token.colleague.clg_hosp_id);
          localStorage.setItem("clgrefId", data.token.colleague.clg_ref_id);
          localStorage.setItem("user_group", data.token.user_group);
          localStorage.setItem(
            "permissions",
            JSON.stringify(data.token.permissions),
          );
          localStorage.setItem("companyID", data.token.colleague.prof_compny);

          if (
            data.token.user_group === "hd" &&
            login.extensions &&
            String(login.extensions) !== "1111"
          ) {
            connectSocket(login.extensions);
          }

          setTimeout(() => {
            const group = data.token.user_group;
            handleAuth();

            if (group === "hd") navigate("/dashboard");
            else if (group === "HR") navigate("/hr/manage profiles");
            else if (group === "M_DASH") navigate("/MM2Dashboard");
            else if (group === "HR Partner")
              navigate("/hr partner/manage professionals");
            else if (group === "ADMIN") navigate("/hhc/dashboard");
            else if (group === "ACCOUNT") navigate("/hhc/account/dashboard");
            else if (group === "REPORTS") navigate("/reports/dashboard");
            else if (group === "HOSPITAL") navigate("/hospital/dashboard");
            else if (group === "ATTENDANCE")
              navigate("/attendance/attendance-view");
            else if (group === "MANAGEMENT")
              navigate("/management/management-dashboard");
            else if (group === "clincal_gov") navigate("/hhc/clinical/closure");
            else if (group === "HHC_Analytics") navigate("/analytics/home");
            else if (group === "physio") navigate("/physio");
            else if (group === "physioMilestone") navigate("/physioMilestone");
            else if (group === "Consultant")
              navigate("/hhc/consultant/referred patient details");

            window.location.reload();
          }, 2000);
        }
      }
    } catch (error) {
      if (error.name === "AbortError") {
        setShowTimeoutAlert(true);
        setTimeout(() => setShowTimeoutAlert(false), 5000);
      } else {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowNetworkDownAlert(true);
          setTimeout(() => setShowNetworkDownAlert(false), 5000);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const onchange = (e) => {
    const { name, value } = e.target;
    setLogin((prev) => ({ ...prev, [name]: value }));
    if (name === "clg_ref_id") setUserIdError(false);
    if (name === "password") setPasswordError(false);
    if (name === "extensions") setExtensionError(false);
  };

  // --- 🔥 BEAUTIFUL FRAMER ANIMATIONS 🔥 ---
  const containerVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 25, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 200, damping: 15 },
    },
  };

  const dropdownVariants = {
    hidden: { opacity: 0, height: 0, marginTop: 0, overflow: "hidden" },
    visible: {
      opacity: 1,
      height: "auto",
      marginTop: 24, // Matches `mt: 3`
      overflow: "visible",
      transition: { duration: 0.3, ease: "easeInOut" },
    },
    exit: {
      opacity: 0,
      height: 0,
      marginTop: 0,
      overflow: "hidden",
      transition: { duration: 0.2, ease: "easeInOut" },
    },
  };

  // Dropdown sirf tab dikhega jab extensions hon (> 0) AUR wo sirf khali "1111" na ho.
  const shouldShowDropdown =
    extensionsList.length > 1 ||
    (extensionsList.length === 1 && String(extensionsList[0]) !== "1111");

  return (
    <div className="container">
      <Dialog
        open={forceLoginOpen}
        onClose={() => {
          if (!forceLoginLoading) {
            setForceLoginOpen(false);
            setPendingLoginValues(null);
          }
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "18px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.18)",
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #0f3a4f 0%, #17647f 100%)",
            px: 3,
            py: 2.5,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              width: 46,
              height: 46,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WarningAmberRoundedIcon
              sx={{
                color: "#fff",
                fontSize: 27,
              }}
            />
          </Box>

          <Box>
            <Typography
              sx={{
                color: "#fff",
                fontSize: "19px",
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              User Already Logged In
            </Typography>
          </Box>
        </Box>

        {/* Content */}
        <DialogContent
          sx={{
            px: 3,
            pt: 3,
            pb: 1.5,
          }}
        >
          {/* Message Box */}
          <Box
            sx={{
              backgroundColor: "#f7fafb",
              border: "1px solid #e2eaee",
              borderRadius: "12px",
              p: 2,
              display: "flex",
              gap: 1.5,
              alignItems: "flex-start",
            }}
          >
            <InfoOutlinedIcon
              sx={{
                color: "#17647f",
                fontSize: 23,
                mt: 0.1,
              }}
            />

            <Typography
              sx={{
                color: "#334155",
                fontSize: "14px",
                lineHeight: 1.6,
              }}
            >
              This user is currently logged in on another session.
              <br />
              <Box
                component="span"
                sx={{
                  fontWeight: 600,
                  color: "#0f3a4f",
                }}
              >
                Do you want to force login and continue?
              </Box>
            </Typography>
          </Box>

          {/* Warning */}
          <Box
            sx={{
              mt: 2,
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 1.5,
              py: 1,
              borderRadius: "8px",
              backgroundColor: "#fff8e6",
            }}
          >
            <WarningAmberRoundedIcon
              sx={{
                color: "#d99400",
                fontSize: 18,
              }}
            />

            <Typography
              sx={{
                color: "#8a6200",
                fontSize: "12px",
                fontWeight: 500,
              }}
            >
              The existing session may be logged out.
            </Typography>
          </Box>
        </DialogContent>

        {/* Actions */}
        <DialogActions
          sx={{
            px: 3,
            pb: 3,
            pt: 1.5,
            gap: 1.5,
          }}
        >
          <Button
            fullWidth
            variant="outlined"
            onClick={() => {
              setForceLoginOpen(false);
              setPendingLoginValues(null);
            }}
            disabled={forceLoginLoading}
            sx={{
              height: 44,
              borderRadius: "10px",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 600,
              color: "#475569",
              borderColor: "#cbd5e1",
              "&:hover": {
                borderColor: "#94a3b8",
                backgroundColor: "#f8fafc",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            fullWidth
            variant="contained"
            onClick={handleForceLogin}
            disabled={forceLoginLoading}
            sx={{
              height: 44,
              borderRadius: "10px",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 600,
              background: "linear-gradient(135deg, #0f3a4f 0%, #17647f 100%)",
              boxShadow: "0 5px 14px rgba(15, 58, 79, 0.25)",
              "&:hover": {
                background: "linear-gradient(135deg, #0b2e3f 0%, #12566e 100%)",
                boxShadow: "0 7px 18px rgba(15, 58, 79, 0.3)",
              },
            }}
          >
            {forceLoginLoading ? (
              <>
                <CircularProgress
                  size={18}
                  sx={{
                    color: "#fff",
                    mr: 1,
                  }}
                />
                Logging in...
              </>
            ) : (
              "Yes, Force Login"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <motion.div
        className="input_fields"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {!isSmallScreen && (
          <motion.div
            variants={itemVariants}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                height: "110px",
                width: "160px",
                borderRadius: "8px",
                marginBottom: "16px",
              }}
            />
          </motion.div>
        )}

        {customAlert && (
          <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
            {customAlert}
          </Alert>
        )}
        {showTimeoutAlert && (
          <Alert severity="warning" variant="filled" sx={{ mt: 2 }}>
            Request timed out.
          </Alert>
        )}
        {showNetworkDownAlert && (
          <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
            Server connection failed.
          </Alert>
        )}
        {showSelect1111Alert && (
          <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
            Extension unavailable.
          </Alert>
        )}
        {successAlert && (
          <Alert severity="success" variant="filled">
            Login Successful!
          </Alert>
        )}
        {showErrorAlert && (
          <Alert severity="error" variant="filled">
            Invalid ID or Password!
          </Alert>
        )}
        {showExistErrorAlert && (
          <Alert severity="error" variant="filled">
            User already logged in!
          </Alert>
        )}
        {showExtAlert && (
          <Alert severity="warning" variant="filled">
            Extension already in use!
          </Alert>
        )}

        {/* User ID Field */}
        <motion.div variants={itemVariants}>
          <Box
            sx={{
              mt: 1,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              borderRadius: "6px",
              border: userIdError ? "1px solid #d32f2f" : "1px solid #000",
            }}
          >
            <img
              src={user}
              alt=""
              style={{ height: "18px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Enter User ID"
              name="clg_ref_id"
              value={login.clg_ref_id}
              onChange={onchange}
              required
            />
          </Box>
          {userIdError && (
            <Typography
              variant="caption"
              color="error"
              sx={{ ml: 1, mt: 0.5, display: "block" }}
            >
              User ID required*
            </Typography>
          )}
        </motion.div>

        {/* Password Field */}
        <motion.div variants={itemVariants}>
          <Box
            sx={{
              mt: 3,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              borderRadius: "6px",
              border: passwordError ? "1px solid #d32f2f" : "1px solid #000",
            }}
          >
            <img
              src={key}
              alt=""
              style={{ height: "20px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 1.2, flex: 1 }}
              placeholder="Enter Password"
              type={showPassword ? "text" : "password"}
              name="password"
              value={login.password}
              onChange={onchange}
              required
            />
            <Button
              onClick={() => setShowPassword(!showPassword)}
              size="small"
              startIcon={showPassword ? <VisibilityOff /> : <Visibility />}
            />
          </Box>
          {passwordError && (
            <Typography
              variant="caption"
              color="error"
              sx={{ ml: 1, mt: 0.5, display: "block" }}
            >
              Password required*
            </Typography>
          )}
        </motion.div>

        {/* 🔥 EXTENSION DROPDOWN WITH ANIMATE PRESENCE 🔥 */}
        <AnimatePresence>
          {shouldShowDropdown && (
            <motion.div
              variants={dropdownVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <Box
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  height: "2.5rem",
                  borderRadius: "6px",
                  border: extensionError
                    ? "1px solid #d32f2f"
                    : "1px solid #000",
                }}
              >
                <PhoneForwardedIcon
                  sx={{
                    fontSize: "18px",
                    ml: 1,
                    color: extensionError ? "#d32f2f" : "black",
                  }}
                />
                <Select
                  displayEmpty
                  name="extensions"
                  value={login.extensions}
                  onChange={onchange}
                  sx={{
                    ml: 1,
                    flex: 1,
                    height: "100%",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Extension
                  </MenuItem>
                  {Array.isArray(extensionsList) &&
                    extensionsList.map((ext, index) => (
                      <MenuItem key={index} value={ext}>
                        {ext}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
              {extensionError && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ ml: 1, mt: 0.5, display: "block" }}
                >
                  Extension required*
                </Typography>
              )}
            </motion.div>
          )}
        </AnimatePresence>

        {/* Submit Button */}
        <motion.div
          variants={itemVariants}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Button
            variant="contained"
            sx={{
              mt: 6,
              width: "100%",
              maxWidth: "28ch",
              height: "7vh",
              backgroundColor: "#69DAC3",
              color: "black",
            }}
            onClick={handleChange}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>
        </motion.div>

        {/* Footer Links */}
        <motion.div variants={itemVariants}>
          <Box
            sx={{
              mt: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {[
                "Privacy & Policy",
                "Refund & Cancellation",
                "Contact Us",
                "About Us",
              ].map((label, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  sx={{ cursor: "pointer", "&:hover": { color: "#0072BC" } }}
                >
                  {label}
                </Typography>
              ))}
            </Box>
          </Box>
        </motion.div>
      </motion.div>
    </div>
  );
}
